import api from './api';
import { MappingConfigResponse } from '../types';

export const mappingApi = {
  /** Fetch current mapping configuration */
  getMappings: async (): Promise<MappingConfigResponse> => {
    const response = await api.get<MappingConfigResponse>('/api/mapping');
    return response.data;
  },

  /** Upload Excel file to update mappings (form-data with file) */
  uploadMappings: async (file: File): Promise<unknown> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await api.post('/api/mapping/upload-mappings', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  /** Delete current mapping configuration */
  deleteMappings: async (): Promise<void> => {
    await api.delete('/api/mapping');
  },
};
